var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarSingleProviderSmsOptedOut = function SvgDefaultAvatarSingleProviderSmsOptedOut(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-9",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    rx: 37
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    stroke: "#EAEAEA",
    strokeWidth: 3.516,
    d: "M30.038 24.345L10.74 8.152c-.622-.521-1.396-.741-2.145-.676-.75.066-1.473.417-1.995 1.039-.522.621-.742 1.396-.676 2.145.065.749.417 1.473 1.038 1.995L26.26 28.848c.622.521 1.396.741 2.145.676.75-.066 1.473-.417 1.995-1.039.522-.621.742-1.396.676-2.145-.065-.749-.417-1.473-1.038-1.995z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarSingleProviderSmsOptedOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--singleProviderSmsOptedOut.3d46ffdee62106ae195db858d9a95037.svg";